import { AppDispatch } from "../../../index";
import { combineReducers } from "redux";
import { all } from "redux-saga/effects";
import account, { accountSaga } from "./account";
import user, { userSaga } from "./user";
import scalp, { scalpSaga } from "./scalp";
import quiz, { quizSaga } from "./quiz";
import loading from "./loading";
import status from "./status";

import { TypedUseSelectorHook, useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { bool } from "yup";

// TODO: 각각의 reducer 타입 선언 후 파일 분리

type QuizInitType = {
  quizState: { [key: number]: { [key: string]: string | number } };
  quizSubmitLoading: boolean;
  quizSubmitDone: boolean;
  quizSubmitError: boolean;
  userQuizData: Record<string, null>;
  issues: any;
  fromLocation: string;
};
const rootReducer = combineReducers<{
  account: any;
  user: any;
  scalp: any;
  loading: any;
  status: any;
  quiz: QuizInitType;
}>({
  account,
  user,
  scalp,
  loading,
  status,
  quiz,
});

export function* rootSaga() {
  yield all([accountSaga(), userSaga(), scalpSaga(), quizSaga()]);
}

export type RootState = ReturnType<typeof rootReducer>;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export default rootReducer;
